import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";

export function InvitedUsersLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.invitedUsers.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
